import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import Button from "@components/Button/Button";
import StackLayout from "@components/layouts/StackLayout/StackLayout";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class Modal extends React.PureComponent {
    static propTypes = {
        visible: PropTypes.bool,
        direction: PropTypes.string,
        title: PropTypes.string,
        status: PropTypes.string,
        onClose: PropTypes.func,
        onClosed: PropTypes.func,
    }
    static defaultProps = {
        visible: false,
        direction: "vertical",
    }

    state = {
        visible: false,
    }

    visible(value) {
        return new Promise(resolve => {
            this._visibleTimeout = setTimeout(() => {
                this.setState({ visible: value === true }, () => setTimeout(() => {
                    const { onClosed } = this.props;
                    resolve();
                    if(value === false && onClosed) onClosed();
                }, 300));
            });
        });
    }

    componentDidMount() {
        const { props } = this;

        if(props.visible === true) this.visible(true);
    }

    componentWillUnmount() {
        if(this._visibleTimeout) clearTimeout(this._visibleTimeout);
    }

    componentDidUpdate(prevProps) {
        const { props } = this;

        if(prevProps.visible !== props.visible) this.visible(props.visible);
    }

    render() {
        const { props, state } = this;
        const { children, direction, title, status, onClose } = props;
        const classes = createClassName(props.className, {
            "Modal": true,
            "visible": state.visible,
            "horizontal": direction === "horizontal",
            "vertical": direction !== "horizontal",
            [status]: !!status,
        });
        const statusIcon = _getIconForStatus(status);

        return (
            <div className={ classes }>
                <div className="Modal-backdrop" onClick={ onClose ? this._onBackdropClick : undefined } />
                <div className="Modal-content-container">
                    <div className="Modal-content">
                        { !!title && (
                            <div className="Modal-title">
                                { !!statusIcon && <div className="Modal-status-icon material-icons">{ statusIcon }</div> }
                                { title }
                            </div>
                        )}

                        { children }
                    </div>
                </div>
            </div>
        );
    }

    // Internal methods
    _onBackdropClick = () => this.props.onClose();

    // Static components
    static Button(props) {
        return (
            <Button { ...props } appearance={ props.appearance || "medium" } size="small" />
        );
    }

    static ButtonsContainer({ children }) {
        return (
            <StackLayout className="Modal-buttons-container" justifyContent="end" fullWidth>{ children }</StackLayout>
        );
    }
}


// PRIVATE FUNCTIONS
function _getIconForStatus(status) {
    switch(status) {
        case "success": return "check_circle";
        case "warning": return "warning";
        case "error": return "error";
        default: return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js